import { SET_STATUS } from '../actionTypes';

export const setStatus = ({ dbSabinaStatus }) => ({
	type: SET_STATUS,
	payload: {
		dbSabinaStatus,
	},
});
